import { HorizontalLine } from "components/primitives";
import { TextArea } from "components/primitives/TextArea";
import { usePropChangedEffect } from "hooks/propChangedEffect";
import { useEffect, useRef } from "react";
import { WidgetFC } from "types/Widget";
import { validationIframeLink } from "util/iframeUtils";

import { EmbedVideo } from "./components";
import { Container, EmbedButton, Title } from "./embed.styles";

interface EmbedContainerProps {
  link?: string;
  placeholder?: string;
  isShowVideo?: boolean;
  hasError?: boolean;
}

export const YoutubeContainer: WidgetFC<EmbedContainerProps> = (props) => {
  const { widgetId, state, setState, settings, setSetting, onToggleFocus, isSettingsOpen } = props;
  const checkSettings = useRef(true);

  useEffect(() => {
    if (checkSettings.current && props.settings?.data?.link) {
      setState({
        link: props.settings?.data.link,
      });
      checkSettings.current = false;
    }
  }, [props.settings]);

  const handleChange = (value: string) => {
    const currentState = {
      link: value,
      isShowVideo: false,
      hasError: false,
    };

    setState(currentState);

    if (isSettingsOpen) {
      setSetting("data", currentState);
    }
  };

  const handleToggleFocus = (isFocus: boolean) => {
    onToggleFocus(isFocus, widgetId);
  };

  const handleShowVideo = () => {
    const isValid = validationIframeLink(state.link);

    if (isValid) {
      setState({
        link: state.link,
        isShowVideo: true,
        hasError: false,
      });
    } else {
      setState({
        link: state.link,
        isShowVideo: false,
        hasError: true,
      });
    }
  };

  usePropChangedEffect(() => {
    if (isSettingsOpen) {
      setState({
        link: settings.data?.link,
        isShowVideo: settings.data?.isShowVideo,
        hasError: settings.data?.hasError,
      });
    }
  }, [settings?.data]);

  if (state.isShowVideo) {
    return <EmbedVideo value={state.link} widgetId={widgetId} onToggleFocus={handleToggleFocus} />;
  }

  return (
    <>
      <Container>
        <Title>Video embed link</Title>

        <HorizontalLine width="100%" margin="0 auto 1.25rem" />

        <TextArea
          placeholder={state?.placeholder}
          onChange={handleChange}
          value={state.link || ""}
          classNames={`${state.hasError ? "animate__shakeX" : ""}`}
          hasError={Boolean(state.link) && state.hasError}
          errorMessage="You need to paste working code"
        />

        <EmbedButton
          type="button"
          color="var(--primary)"
          disabled={!state.link}
          onClick={handleShowVideo}
        >
          Embed
        </EmbedButton>
      </Container>
    </>
  );
};
